export default __webpack_public_path__ + "static/newsletter-blue-background-e0df9512209787c2969c0ba558f9a5cc.mp4";